import { motion, useAnimation } from "framer-motion";
import { useEffect, memo } from "react";
import { useInView } from "react-intersection-observer";
import { Props } from "@/models";

const AniminateOnScroll: React.FC<Props.AniminateOnScroll> = ({
  children,
  initialPosition,
  className,
  duration,
}) => {
  const controls = useAnimation();
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView) {
      controls.start({
        x: 0,
        transition: { ease: "easeInOut", duration: duration ?? 4.0 },
      });
    } else {
      controls.start({ x: initialPosition });
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
     // animate={controls}
      //initial={{ x: initialPosition }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
export const MemoizedAniminateOnScroll = memo(AniminateOnScroll);
